@if (attachForm) {
  @if (isDzBankUser) {
    <div [formGroup]="attachForm">
      <div class="flex flex-column gap-1">
        <div class="flex flex-row align-items-center w-28rem">
          <label class="w-13rem justify-content-start" for="kreditlinieId">
            {{ 'investment.label.verfuegbarkeit.linie' | translate }}
          </label>
          <p-input-group>
            <input class="text-right" pInputText appAmountInput formControlName="kreditline" id="kreditlinieId">
          </p-input-group>
        </div>
        <div class="flex flex-row align-items-center w-28rem">
          <label class="w-13rem" for="availability0Id">
            {{ this.overNightDate | date }}
          </label>
          <p-input-group>
            <input class="text-right" pInputText appAmountInput formControlName="availability0" id="availability0Id">
          </p-input-group>
        </div>
        <div class="flex flex-row w-28rem align-items-center">
          <label class="w-13rem" for="availabilityTId">
            {{ this.tomorrowDate | date }}
          </label>
          <p-input-group>
            <input class="text-right" pInputText appAmountInput formControlName="availabilityT" id="availabilityTId">
          </p-input-group>
        </div>
        <div class="flex flex-row w-28rem align-items-center">
          <label class="w-13rem" for="availabilitySPId">
            {{ this.spotDate | date }}
          </label>
          <p-input-group>
            <input class="text-right" pInputText appAmountInput formControlName="availabilitySP" id="availabilitySPId">
          </p-input-group>
        </div>
      </div>
    </div>
  }
}
